export default {
  alphanumericRegex: /^[a-zA-Z0-9-_&,/ ]*$/
}
